"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var auth_exports = {};
__export(auth_exports, {
  authHeader: () => authHeader,
  basicAuth: () => basicAuth,
  bearerAuth: () => bearerAuth,
  isApiAuth: () => isApiAuth,
  isBasicAuth: () => isBasicAuth,
  isBearerAuth: () => isBearerAuth
});
module.exports = __toCommonJS(auth_exports);
var import_guard = require("@cartographerio/guard");
var import_base_64 = __toESM(require("base-64"));
var import_auth = require("../auth/index.js");
function isBearerAuth(obj) {
  return (0, import_guard.isObject)(obj) && (0, import_guard.hasTypeTag)(obj, "BearerAuth") && (0, import_guard.hasKey)(obj, "token", import_auth.isAccessToken);
}
function isBasicAuth(obj) {
  return (0, import_guard.isObject)(obj) && (0, import_guard.hasTypeTag)(obj, "BasicAuth") && (0, import_guard.hasKey)(obj, "encoded", import_guard.isString);
}
function isApiAuth(obj) {
  return isBearerAuth(obj) || isBasicAuth(obj);
}
function bearerAuth(token) {
  return { type: "BearerAuth", token };
}
function basicAuth(email, password) {
  return {
    type: "BasicAuth",
    encoded: import_base_64.default.encode(`${email}:${password}`)
  };
}
function authHeader(auth) {
  switch (auth.type) {
    case "BearerAuth":
      return `Bearer ${auth.token}`;
    case "BasicAuth":
      return `Basic ${auth.encoded}`;
  }
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  authHeader,
  basicAuth,
  bearerAuth,
  isApiAuth,
  isBasicAuth,
  isBearerAuth
});
//# sourceMappingURL=auth.js.map
